'use client'
import { useContextElement } from '@/context/Context'
import Link from 'next/link'
import React, { useEffect, useRef } from 'react'

export default function MobileFooter1({ storeInfo }) {
  const footerRef = useRef(null)
  const { wishList } = useContextElement()
  const hasWishlist = storeInfo?.WishlistButtonEnable
  const itemColClass = hasWishlist ? 'col-3' : 'col-4'

  useEffect(() => {
    const updateFooterHeight = () => {
      if (footerRef.current) {
        const h = footerRef.current.offsetHeight
        document.documentElement.style.setProperty(
          '--mobile-footer-height',
          `${h}px`
        )
      }
    }

    updateFooterHeight()
    window.addEventListener('resize', updateFooterHeight)

    return () => window.removeEventListener('resize', updateFooterHeight)
  }, [])

  return (
    <footer
      ref={footerRef}
      id="footer"
      className="footer-mobile container w-100 px-5 d-block d-md-none bg-body position-fixed"
      style={{ bottom: 0, left: 0, zIndex: 1000 }}
    >
      <div className="row text-center">
        <div className={itemColClass}>
          <Link
            href="/"
            className="footer-mobile__link d-flex flex-column align-items-center"
          >
            <svg
              className="d-block"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <use href="#icon_home" />
            </svg>
            <span>主頁</span>
          </Link>
        </div>
        {/* <!-- /.col-3 --> */}

        <div className={itemColClass}>
          <Link
            href="/product-list"
            className="footer-mobile__link d-flex flex-column align-items-center"
          >
            <svg
              className="d-block"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <use href="#icon_hanger" />
            </svg>
            <span>商品</span>
          </Link>
        </div>
        {/* <!-- /.col-3 --> */}

        <div className={itemColClass}>
          <Link
            href="/MemberCenter/account_dashboard"
            className="footer-mobile__link d-flex flex-column align-items-center"
          >
            <svg
              className="d-block"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.5 20C5.45274 16.8825 8.33459 14.75 12 14.75C15.6654 14.75 18.5473 16.8825 19.5 20"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>會員專區</span>
          </Link>
        </div>
        {/* <!-- /.col-3 --> */}

        {hasWishlist && (
          <div className={itemColClass}>
            <Link
              href="/MemberCenter/account_wishlist"
              className="footer-mobile__link d-flex flex-column align-items-center"
            >
              <div className="position-relative">
                <svg
                  className="d-block"
                  width="18"
                  height="18"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <use href="#icon_heart" />
                </svg>
                <span className="wishlist-amount d-block position-absolute js-wishlist-count">
                  {wishList.length}
                </span>
              </div>
              <span>願望清單</span>
            </Link>
          </div>
        )}
        {/* <!-- /.col-3 --> */}
      </div>
      {/* <!-- /.row --> */}
    </footer>
  )
}
